module.exports = __webpack_public_path__ + "assets/quoteRight.32d4565e1b5d0f2a32a6bbba95e15352.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/level/quoteRight.svg
// module id = 864
// module chunks = 0